import { createSelector } from 'reselect'

// const sortSourcesByName = (sourceA, sourceAB) => {
//   return sourceA.value?.name
//     ?.replace(/\W+/g, '')
//     ?.localeCompare(sourceAB.value?.name?.replace(/\W+/g, ''))
// }

const getSources = ({ source }) => source?.records
const getSourceByName = ({ source }, name) =>
  source.records.find((source) => source?.value?.name === name)

const sourceSelectors = {
  getSourceOptions: createSelector([getSources], (sources) => {
    return sources
  }),

  getSourceByName: createSelector([getSourceByName], (source) => source),
}

export default sourceSelectors
